import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToRehabilitationFormBean } from './ReferralToRehabilitationForm/ReferralToRehabilitationForm.types';
import { referralToRehabilitationDraftSchema } from './referralToRehabilitation.draft';

type ReferralToRehabilitationPanelLoaderChildrenProps = {
   referralToRehabilitationDraft: ReferralToRehabilitationFormBean | null;
};
type ReferralToRehabilitationPanelLoaderProps = {
   readonly children: ({
      referralToRehabilitationDraft,
   }: ReferralToRehabilitationPanelLoaderChildrenProps) => JSX.Element;
   readonly visitId: number;
};

export const ReferralToRehabilitationPanelLoader = (props: ReferralToRehabilitationPanelLoaderProps): JSX.Element => {
   const {
      data: referralToRehabilitationDraft,
      loading: referralToRehabilitationDraftLoading,
      error: referralToRehabilitationDraftError,
   } = useDraftCqrsFind(
      { token: getReferralDraftToken('referralToRehabilitation', props.visitId) },
      referralToRehabilitationDraftSchema
   );

   if (referralToRehabilitationDraftLoading) {
      return <LoaderSpinner />;
   }

   if (referralToRehabilitationDraftError) {
      return (
         <Message
            testId={'referralToRehabilitationFetchError'}
            type={MessageType.NEGATIVE}
            label={referralTranslationKeys.referralFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      referralToRehabilitationDraft: referralToRehabilitationDraft?.contents ?? null,
   });
};
